import { Link } from "react-router-dom";
import Navigation from "@/components/Navigation";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import CheckoutDisclaimer from "@/components/CheckoutDisclaimer";

const MOCK = [
  { id: '1', title: 'DXB → ATH Flights', category: 'travel', price_aed: 2400, description: 'Round-trip flights from Dubai to Athens with flexible dates' },
  { id: '2', title: 'Pediatric Checkup Package', category: 'healthcare', price_aed: 800, description: 'Comprehensive health checkup for children aged 5-12' },
  { id: '3', title: 'Wedding Venue Deposit', category: 'weddings', price_aed: 5000, description: 'Secure your dream wedding venue with flexible payment options' },
  { id: '4', title: 'Professional Photography Session', category: 'services', price_aed: 1200, description: 'Family or corporate photography with high-quality editing' },
  { id: '5', title: 'Dental Treatment Package', category: 'healthcare', price_aed: 3500, description: 'Complete dental care including cleaning and fillings' },
  { id: '6', title: 'Fitness Bootcamp Membership', category: 'fitness', price_aed: 900, description: '6-month premium gym membership with personal training' },
];

const getCategoryColor = (category: string) => {
  switch (category) {
    case 'travel': return 'bg-blue-100 text-blue-800';
    case 'healthcare': return 'bg-green-100 text-green-800';
    case 'weddings': return 'bg-pink-100 text-pink-800';
    case 'services': return 'bg-purple-100 text-purple-800';
    case 'fitness': return 'bg-orange-100 text-orange-800';
    default: return 'bg-gray-100 text-gray-800';
  }
};

export default function Listings() {
  return (
    <div className="min-h-screen bg-background">
      <Navigation />
      
      <div className="container mx-auto px-4 py-8">
        <div className="max-w-5xl mx-auto">
          <div className="mb-8">
            <h1 className="text-3xl font-bold text-foreground mb-2">Explore milestone options</h1>
            <p className="text-muted-foreground">
              Discover flexible payment solutions for life's important moments
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 mb-12">
            {MOCK.map((listing) => (
              <Link key={listing.id} to={`/listing/${listing.id}`}>
                <Card className="h-full hover:shadow-lg transition-shadow cursor-pointer">
                  <CardHeader>
                    <div className="flex items-center justify-between mb-2">
                      <Badge className={getCategoryColor(listing.category)}>
                        {listing.category}
                      </Badge>
                      <span className="text-lg font-semibold text-primary">
                        AED {listing.price_aed.toLocaleString()}
                      </span>
                    </div>
                    <CardTitle className="text-lg">{listing.title}</CardTitle>
                  </CardHeader>
                  <CardContent>
                    <CardDescription className="mb-4">
                      {listing.description}
                    </CardDescription>
                    <div className="text-sm text-muted-foreground">
                      From AED {Math.ceil(listing.price_aed / 12)} / mo over 12 months
                    </div>
                  </CardContent>
                </Card>
              </Link>
            ))}
          </div>

          {/* Always show disclaimers */}
          <div className="border-t pt-8">
            <CheckoutDisclaimer
              exampleAmount="From AED 200 / mo over 12 months via Tabby"
              notes={[
                'Subject to approval by provider.',
                'Flexaura is a marketplace and does not lend.',
                'Eligibility, fees, and terms are shown before you confirm.'
              ]}
            />
          </div>
        </div>
      </div>
    </div>
  );
}